import { JsonObject, JsonProperty } from 'json2typescript'
import DateConverter from '@/converters/DateConverter'
import { DefinedListDetail } from './DefinedList'
import Model from './Model'
import TransactionType from './TransactionType'

@JsonObject('PolicyHistory')
export default class PolicyHistory extends Model {
  @JsonProperty('type', TransactionType)
  type: TransactionType

  @JsonProperty('transactionDate', DateConverter)
  transactionDate: Date

  @JsonProperty('paymentType', DefinedListDetail)
  paymentType: DefinedListDetail

  @JsonProperty('amount', Number)
  amount: number

  @JsonProperty('isOutstanding', Boolean)
  isOutstanding: boolean

  constructor(
    id: number,
    type: TransactionType,
    transactionDate: Date,
    paymentType: DefinedListDetail,
    amount: number,
    isOutstanding: boolean,
  ) {
    super(id)
    this.type = type
    this.transactionDate = transactionDate
    this.paymentType = paymentType
    this.amount = amount
    this.isOutstanding = isOutstanding
  }
}
